import "./rangeSlider.scss";
import { Slider } from "@mui/material";
import { Input } from "@mui/material";

const RangeSlider = ({
  initialValue = 22,
  min = 5,
  max = 231,
  step = 1,
  unit = "cm",
  label,
  minValue,
  maxValue,
  onChange,
}) => {

  const handleChange = (event, newValue, finishedEdit) => {
    if (isNaN(newValue)) {
      return ""
    } else if (finishedEdit) {
      if (newValue == "") {
        newValue = min
      }
      if (newValue > max) {
        newValue = max
      } else if (newValue < min) {
        newValue = min
      }
      removeFocusFromWrapper(event);
    }

    if (onChange) {
      onChange(newValue);
    }
  };

  function valueLabelFormat(value) {
    return `${value}${unit}`;
  }

  function removeFocusFromWrapper(event) {
    event.target.parentNode.parentNode.style.borderColor = "#DDDDDD";
  }

  function getInputLabel(initialValue, unit) {
    return (
      <>
        <div className="fillableText">
          <Input
            sx={{
              "& .MuiInputBase-input": {
                padding: "0px",
                width: "5ch",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 600,
              },
            }}
            value={initialValue}
            disableUnderline={true}
            onChange={(e) => handleChange(e, e.target.value)}
            onBlur={(e) => handleChange(e, e.target.value, true)}
            onFocus={(e) => e.target.parentNode.parentNode.style.borderColor = "#000"}
          />
          <span className="pl-1">{unit}</span>
        </div>
      </>
    )
  }

  return (
    <div className="range">
      <p className="rangeTxt">
        <span>{label}</span>
        {getInputLabel(initialValue, unit)}
      </p>
      <Slider
        value={initialValue}
        min={min}
        step={step}
        max={max}
        getAriaValueText={valueLabelFormat}
        valueLabelFormat={valueLabelFormat}
        onChange={handleChange}
        valueLabelDisplay="auto"
        aria-labelledby="non-linear-slider"
      />
      <div className="minMax">
        <span>{minValue}</span>
        <span>{maxValue}</span>
      </div>
    </div>
  );
};

export default RangeSlider;
